import confetti from 'canvas-confetti';
import { useEffect } from 'react';

function randomInRange(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

interface ConfettiProps {
  active: boolean;
  duration?: number;
  particleDensity?: number;
}

/**
 * Component that renders confetti effect when active is true.
 */
export default function Confetti({ 
  active, 
  duration = 3000, 
  particleDensity = 50 
}: ConfettiProps) {
  useEffect(() => {
    if (active) {
      // Launch confetti
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

      const interval: any = setInterval(() => {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = particleDensity * (timeLeft / duration);

        // Launch confetti from both sides
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
        });
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
        });
      }, 250);

      // Clean up the interval when the component unmounts or when active becomes false
      return () => clearInterval(interval);
    }
  }, [active, duration, particleDensity]);

  // This component doesn't render anything visible
  return null;
}